import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { I18nContext } from '../../../providers/i18n';
import './styles.scss';

const VotingTitle = ({ title, className = '' }) => {
  const { t } = useContext(I18nContext);
  return (
    <div className={`voting-title-container ${className}`}>
      <span>{t('vote.template')}</span> <span className="voting-title-bold">{title}</span>
    </div>
  );
};

VotingTitle.propTypes = {
  title: PropTypes.string.isRequired
};

export default VotingTitle;
